import {createGlobalStyle} from 'styled-components';
import styledNormalize from 'styled-normalize';

const GlobalStyle = createGlobalStyle`
  ${styledNormalize}
  * {
    box-sizing: border-box;
    outline: none !important;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }
  *:not(input, textarea) {
    user-select: none;
    -moz-user-select: -moz-none;
    -webkit-user-select: none;
  }
  body {
    font-family: ${(p) => p.theme.font.family.text};
    font-weight: normal;
    line-height: ${(p) => p.theme.font.lineHeight.base};
    letter-spacing: ${(p) => p.theme.font.letterSpacing.base};
    background-color: white;
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${(p) => p.theme.colors.black};
    font-family: ${(p) => p.theme.font.family.header};
  }
  h1 {
    font-size: ${(p) => p.theme.font.size.h1};
  }
  h2 {
    font-size: ${(p) => p.theme.font.size.h2};
  }
  h3 {
    font-size: ${(p) => p.theme.font.size.h3};
  }
  h4 {
    font-size: ${(p) => p.theme.font.size.h4};
  }
  h5 {
    font-size: ${(p) => p.theme.font.size.h5};
  }
  h6 {
    font-size: ${(p) => p.theme.font.size.h6};
  }
  p {
    color: ${(p) => p.theme.colors.black};
    font-size: ${(p) => p.theme.font.size.base};
  }
  .reorder-wrapper-item {
    position: relative;
    transition: top 1s ease-in;
  }
`;

export default GlobalStyle;
